export const initHeaderVisibility = () => {
  const header = document.querySelector('#header');
  const sideNavOther = document.querySelector('.side-nav.-other');
  if (!header) return;

  const SCROLL_THRESHOLD = 5;
  const THRESHOLD_OFFSET = 5;

  let prevY = window.scrollY;
  let anchorScrolling = false;
  let scrollEndTimer = null;
  let cachedThreshold = 0;
  let rafId = null;
  const isTeacherPage = !!document.querySelector('.site-wrap.teacher');
  const mql = window.matchMedia('(max-width: 990px)');

  const updateThreshold = () => {
    const headerH = header.offsetHeight;
    cachedThreshold = (sideNavOther && mql.matches)
      ? headerH + sideNavOther.offsetHeight
      : headerH;
  };
  updateThreshold();

  const hideNav = () => {
    header.classList.add('up-hidden');
    if (sideNavOther && mql.matches) sideNavOther.classList.add('up-hidden');
  };

  const showNav = () => {
    header.classList.remove('up-hidden');
    if (sideNavOther && mql.matches) sideNavOther.classList.remove('up-hidden');
  };

  const onScroll = () => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      const currentY = window.scrollY;
      const scrollDifference = Math.abs(currentY - prevY);

      if (anchorScrolling) {
        if (!isTeacherPage && currentY > cachedThreshold + THRESHOLD_OFFSET) {
          hideNav();
        }
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(() => {
          anchorScrolling = false;
          prevY = window.scrollY;
        }, 300);
        prevY = currentY;
        return;
      }

      if (currentY > cachedThreshold + THRESHOLD_OFFSET) {
        if (currentY < prevY - 1) {
          showNav();
        } else if (scrollDifference > SCROLL_THRESHOLD) {
          hideNav();
        }
      } else {
        showNav();
      }

      prevY = currentY;
    });
  };

  const handleAnchorClick = () => {
    anchorScrolling = true;
    if (isTeacherPage) {
      showNav();
    } else {
      hideNav();
    }
  };

  const anchorLinks = document.querySelectorAll('a[href*="#"]:not([href="#body"]):not([href="#"])');
  anchorLinks.forEach(link => {
    link.addEventListener('click', handleAnchorClick);
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateThreshold);
  window.addEventListener('orientationchange', updateThreshold);
  window.addEventListener('load', updateThreshold);
  mql.addEventListener('change', updateThreshold);

  return () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', updateThreshold);
    window.removeEventListener('orientationchange', updateThreshold);
    window.removeEventListener('load', updateThreshold);
    mql.removeEventListener('change', updateThreshold);
    anchorLinks.forEach(link => {
      link.removeEventListener('click', handleAnchorClick);
    });
    if (rafId !== null) cancelAnimationFrame(rafId);
    if (scrollEndTimer) clearTimeout(scrollEndTimer);
  };
};
